import { Schema } from 'rsuite'

export const StorageContainerFormValidationModel = Schema.Model({
  container_id: Schema.Types.StringType()
    .isRequired('Введите код контейнера')
    .minLength(1, 'Код контейнера должен содержать минимум 1 символ')
    .maxLength(50, 'Код контейнера должен содержать максимум 50 символов'),
  
  size: Schema.Types.StringType()
    .isRequired('Выберите размер'),
  
  type: Schema.Types.StringType()
    .isRequired('Выберите тип'),
  
  description: Schema.Types.StringType()
    .maxLength(500, 'Описание должно содержать максимум 500 символов'),
  
  sanitization_interval_days: Schema.Types.NumberType()
    .min(1, 'Интервал должен быть не менее 1 дня')
})
